import axios from "axios";
import { File } from "../models/File";
const API_BASE_URL = process.env.REACT_APP_AUDIT_API_URL;

class FileUploadService {
  static async authorize(): Promise<{ authorizationUrl: string }> {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/DropboxUpload/authorize`
      );
      return response.data;
    } catch (error) {
      console.error("Authorization failed:", error);
      throw error; // Re-lanza el error para que el componente lo maneje
    }
  }

  static async getFiles(questionaryId: number): Promise<File[]> {
    const response = await axios.get(
      `${API_BASE_URL}/DropboxUpload/files/${questionaryId}`
    );
    return response.data;
  }

  static async getFilesQuestion(questionId: number): Promise<File[]> {
    const response = await axios.get(
      `${API_BASE_URL}/DropboxUpload/filesquestion/${questionId}`
    );
    return response.data;
  }

  static async getFilesAnswer(
    questionaryId: number,
    questionId: number
  ): Promise<File[]> {
    const response = await axios.get(
      `${API_BASE_URL}/DropboxUpload/filesanswer/${questionaryId}/${questionId}`
    );
    return response.data;
  }

  static async uploadFiles(
    questionaryId: number,
    files: FileList
  ): Promise<File[]> {
    const formData = new FormData();
    Array.from(files).forEach((file) => {
      formData.append("files", file);
    });

    const response = await axios.post(
      `${API_BASE_URL}/DropboxUpload/upload/${questionaryId}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return response.data;
  }

  static async uploadFilesQuestion(
    questionId: number,
    files: FileList
  ): Promise<File[]> {
    const formData = new FormData();
    Array.from(files).forEach((file) => {
      formData.append("files", file);
    });

    const response = await axios.post(
      `${API_BASE_URL}/DropboxUpload/uploadfq/${questionId}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return response.data;
  }

  static async uploadFilesAnswer(
    questionaryId: number,
    questionId: number,
    files: FileList
  ): Promise<File[]> {
    const formData = new FormData();
    Array.from(files).forEach((file) => {
      formData.append("files", file);
    });

    const response = await axios.post(
      `${API_BASE_URL}/DropboxUpload/uploadfa/${questionaryId}/${questionId}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return response.data;
  }

  static async deleteFile(fileId: number): Promise<void> {
    await axios.post(`${API_BASE_URL}/DropboxUpload/file/${fileId}`);
  }
}

export default FileUploadService;
